import { render, staticRenderFns } from "./my_suggest.vue?vue&type=template&id=3193a408"
import script from "./my_suggest.vue?vue&type=script&lang=js"
export * from "./my_suggest.vue?vue&type=script&lang=js"
import style0 from "./my_suggest.vue?vue&type=style&index=0&id=3193a408&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports